<template>
  <div class="customer-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">客户管理</span>
      </div>
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="selectedIds.length === 0" @click="handleDelete">删除</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleImport">导入客户</el-button>
        <el-button type="primary" icon="el-icon-picture" @click="openOcrDialog">图片识别</el-button>
        <el-button type="warning" :disabled="selectedIds.length === 0" @click="openBatchAssignment">批量分配</el-button>
        <el-button type="info" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-bar">
      <el-input v-model="queryParams.userInfo" placeholder="用户信息" clearable style="width: 150px" @keyup.enter="handleQuery" />
      <el-input v-model="queryParams.contact" placeholder="联系方式" clearable style="width: 150px; margin-left: 10px;" @keyup.enter="handleQuery" />
      <el-input v-model="queryParams.cityRemark" placeholder="城市备注" clearable style="width: 150px; margin-left: 10px;" @keyup.enter="handleQuery" />
      <el-input v-model="queryParams.leadPath" placeholder="留资路径" clearable style="width: 150px; margin-left: 10px;" @keyup.enter="handleQuery" />
      <el-select
        v-model="queryParams.assignedUserId"
        placeholder="分配员工"
        clearable
        filterable
        style="width: 180px; margin-left: 10px;"
        @visible-change="loadAssignableUsers"
      >
        <el-option
          v-for="user in assignableUserOptions"
          :key="user.id"
          :label="`${user.userName}(${user.nickName})`"
          :value="user.id"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleQuery" style="margin-left: 10px;">搜索</el-button>
      <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
      v-loading="loading"
      :data="customerList"
      @selection-change="handleSelectionChange"
      row-key="id"
      stripe
      :max-height="tableMaxHeight"
    >
      <el-table-column type="selection" width="50" align="center" />
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ getRowIndex(scope.$index) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" width="160">
        <template slot-scope="scope">
          <div class="cell-with-image">
            <el-image
              v-if="scope.row.ocrImageUrl"
              :src="scope.row.ocrImageUrl"
              fit="cover"
              class="table-image"
              :preview-src-list="[scope.row.ocrImageUrl]"
            />
            <el-image
              v-if="scope.row.customerImageUrl"
              :src="scope.row.customerImageUrl"
              fit="cover"
              class="table-image"
              :preview-src-list="[scope.row.customerImageUrl]"
            />
            <span>{{ formatDate(scope.row.createTime) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户信息" align="center" prop="userInfo" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="联系方式" align="center" prop="contact" width="130" />
      <el-table-column label="城市备注" align="center" prop="cityRemark" min-width="100" :show-overflow-tooltip="true" />
      <el-table-column label="留资路径" align="center" prop="leadPath" min-width="100" :show-overflow-tooltip="true" />
      <el-table-column label="特征标签" align="center" prop="featureTags" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="备注" align="center" prop="remark" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="已分配员工" align="center" prop="assignUserNames" min-width="150" :show-overflow-tooltip="true" />
      <el-table-column label="操作" width="320">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openAssignment(scope.row)">分配员工</el-button>
          <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button type="text" size="small" class="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <span class="total-text">共 {{ total }} 条记录</span>
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="queryParams.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>

    <!-- 新增/修改对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px" append-to-body>
      <el-form ref="customerFormRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户信息" prop="userInfo">
          <el-input v-model="form.userInfo" placeholder="请输入用户信息" />
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="城市备注" prop="cityRemark">
          <el-input v-model="form.cityRemark" placeholder="请输入城市备注" />
        </el-form-item>
        <el-form-item label="留资路径" prop="leadPath">
          <el-input v-model="form.leadPath" placeholder="请输入留资路径" />
        </el-form-item>
        <el-form-item label="特征标签" prop="featureTags">
          <el-input v-model="form.featureTags" placeholder="请输入特征标签" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="客户图片" prop="customerImageUrl">
          <div class="image-upload" @click="triggerImageUpload" v-if="!form.customerImageUrl">
            <i class="el-icon-plus"></i>
            <span>上传图片</span>
          </div>
          <div v-else class="image-preview-wrapper">
            <el-image
              :src="form.customerImageUrl"
              fit="cover"
              class="upload-preview"
              :preview-src-list="[form.customerImageUrl]"
            />
            <div class="image-actions">
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click.stop="removeFormImage"></el-button>
            </div>
          </div>
          <input type="file" ref="imageInput" accept="image/*" style="display: none" @change="handleImageChange" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分配员工对话框 -->
    <el-dialog title="分配员工" :visible.sync="assignmentDialog.visible" width="600px" append-to-body>
      <div class="assignment-search">
        <el-select
          v-model="assignmentDialog.tempUserId"
          filterable
          clearable
          remote
          placeholder="搜索用户名/昵称"
          style="width: 100%"
          :remote-method="loadSearchResults"
          :loading="assignmentDialog.loading"
          @change="confirmAssignmentUser"
          @visible-change="handleUserDropdownChange"
        >
          <el-option
            v-for="item in assignmentDialog.searchResults"
            :key="item.id"
            :label="`${item.userName}(${item.nickName})`"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-table :data="assignmentDialog.list" max-height="350" border style="margin-top: 12px">
        <el-table-column label="用户名" align="center" prop="userName" />
        <el-table-column label="用户昵称" align="center" prop="nickName" />
        <el-table-column label="操作" align="center" width="320">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="handleUnassignUser(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignmentDialog.visible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 批量分配员工对话框 -->
    <el-dialog title="批量分配员工" :visible.sync="batchDialog.visible" width="1000px" append-to-body>
      <el-table v-loading="batchDialog.loading" :data="batchDialog.items" max-height="420" border>
        <el-table-column label="用户信息" min-width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.userInfo || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" min-width="150" align="center" prop="contact" />
        <el-table-column label="添加员工" min-width="160" align="center">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.tempUserId"
              filterable
              remote
              clearable
              placeholder="用户名/用户昵称"
              style="width: 100%;"
              :remote-method="(kw) => loadBatchSearchResults(scope.$index, kw)"
              :loading="scope.row.loading"
              @change="(value) => confirmBatchUser(scope.$index, value)"
              @visible-change="(v) => v && loadBatchSearchResults(scope.$index, '')"
            >
              <el-option
                v-for="item in scope.row.searchResults || []"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="已分配员工" min-width="280" align="center">
          <template slot-scope="scope">
            <div v-if="!scope.row.assignedList || scope.row.assignedList.length === 0" style="color:#909399;">暂未分配</div>
            <el-tag
              v-for="user in scope.row.assignedList || []"
              :key="user.userId"
              style="margin-right:6px;"
              closable
              @close="removeBatchAssignedUser(scope.$index, user.userId)"
            >
              {{ user.userName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button link type="primary" @click="copyPreviousAssignment(scope.$index)" :disabled="scope.$index === 0">复制上一条</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog.visible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog title="导入客户" :visible.sync="importDialog.visible" width="600px" append-to-body>
      <div class="import-content">
        <el-upload
          ref="importUpload"
          :limit="1"
          accept=".xlsx,.xls"
          :auto-upload="false"
          :on-change="handleImportFileChange"
          :file-list="importDialog.fileList"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            <el-link type="primary" @click="downloadTemplate">下载模板</el-link>
            <div style="color: #909399; font-size: 12px; margin-top: 8px;">
              导入后将直接新增客户资料，并自动为导入的客户绑定所选员工
            </div>
          </div>
        </el-upload>
        <div v-if="importDialog.batchAssignUserIds.length > 0" style="margin-top: 12px;">
          <span style="color: #606266;">导入后自动分配员工：</span>
          <el-tag
            v-for="userId in importDialog.batchAssignUserIds"
            :key="userId"
            style="margin-right: 6px;"
            closable
            @close="removeBatchAssignUser(userId)"
          >
            {{ getUserName(importDialog.batchUserMap[userId]) }}
          </el-tag>
          <el-button v-if="!importDialog.showUserSelect" link type="primary" @click="showImportUserSelect">添加员工</el-button>
          <el-select
            v-if="importDialog.showUserSelect"
            v-model="importDialog.tempUserId"
            filterable
            clearable
            remote
            reserve-keyword
            placeholder="搜索用户"
            style="width: 180px; margin-left: 6px;"
            :remote-method="searchImportUser"
            @change="confirmImportUser"
          >
            <el-option
              v-for="item in importDialog.userOptions"
              :key="item.id"
              :label="`${item.userName}(${item.nickName})`"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialog.visible = false">取 消</el-button>
        <el-button type="primary" :loading="importDialog.loading" @click="submitImport">确定导入</el-button>
      </div>
    </el-dialog>

    <!-- 图片识别对话框 -->
    <el-dialog title="图片识别导入客户" :visible.sync="ocrDialog.visible" width="900px" append-to-body>
      <div style="display: flex; flex-direction: column; gap: 16px;">
        <div class="import-content">
          <div v-if="!ocrDialog.uploaded">
            <el-upload
              ref="ocrUploadRef"
              :limit="1"
              accept="image/*"
              :auto-upload="true"
              :http-request="handleOcrUpload"
              :on-change="handleOcrChange"
              drag
            >
              <div style="display: flex; flex-direction: column; align-items: center;">
                <i class="el-icon-upload" style="font-size: 40px; color: #c0c4cc;"></i>
                <div class="el-upload__text">将表格图片拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip" style="color: #909399; font-size: 12px; margin-top: 5px;">
                  仅支持图片
                </div>
              </div>
            </el-upload>
          </div>
          <div v-if="ocrDialog.uploaded" style="position: relative; display: flex; flex-direction: column; align-items: stretch; gap: 8px;">
            <div style="position: relative; width: 100%; height: 100px; border: 1px solid #dcdfe6; border-radius: 4px; background: #f5f7fa;">
              <el-image
                v-if="ocrDialog.currentUploadedImage"
                :src="ocrDialog.currentUploadedImage"
                :preview-src-list="[ocrDialog.currentUploadedImage]"
                fit="contain"
                style="width: 100%; height: 100%;"
              />
              <div v-else style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
                <i class="el-icon-loading" style="font-size: 24px; color: #409eff;"></i>
              </div>
            </div>
            <span v-if="!ocrDialog.recognized" style="font-size: 12px; color: #909399; display: block; text-align: center;">大约需要5-30秒识别出结果，请耐心等待</span>
            <el-button
              v-if="ocrDialog.recognized"
              type="danger"
              size="small"
              @click="handleOcrRemove"
            >
              <i style="margin-right: 4px;" class="el-icon-close"></i>删除
            </el-button>
          </div>
        </div>
        <div v-if="ocrDialog.previewTable.length > 0">
          <div style="font-size: 13px; color: #606266; margin-bottom: 8px; font-weight: 500;">分配员工（导入后自动分配给该员工）：</div>
          <el-select
            v-model="ocrDialog.selectedUserId"
            filterable
            clearable
            placeholder="请选择员工"
            style="width: 100%;"
          >
            <el-option
              v-for="item in ocrDialog.userOptions"
              :key="item.id"
              :label="`${item.userName}(${item.nickName})`"
              :value="item.id"
            />
          </el-select>
        </div>
        <div v-if="ocrDialog.previewTable.length > 0" style="flex: 1; min-width: 0;">
          <el-table :data="ocrDialog.previewTable" border max-height="380" style="width: 100%;">
            <el-table-column label="序号" width="70" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column label="图片" width="80" align="center">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <el-image
                    v-if="scope.row.customerImageUrl"
                    :src="scope.row.customerImageUrl"
                    fit="cover"
                    style="width: 36px; height: 36px; border-radius: 4px; cursor: pointer;"
                    @click="openImagePreview(scope.row.customerImageUrl)"
                  />
                  <div v-if="!scope.row.customerImageUrl" style="position: relative;">
                    <el-button
                      type="primary"
                      link
                      size="small"
                      :loading="scope.row._uploading"
                      @click="triggerRowUpload(scope.$index)"
                    >
                      <i class="el-icon-plus"></i>
                    </el-button>
                    <input
                      :ref="el => setRowUploadRef(el, scope.$index)"
                      type="file"
                      accept="image/*"
                      style="display: none;"
                      @change="e => handleRowFileSelect(e, scope.$index)"
                    />
                  </div>
                  <el-button
                    v-if="scope.row.customerImageUrl"
                    type="text"
                    size="mini"
                    style="color: #f56c6c; padding: 0 4px; margin-left: 4px;"
                    @click="removeOcrRowImage(scope.$index)"
                  >
                    <i class="el-icon-close" style="font-size: 14px;"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="留资时间">
              <template slot-scope="scope">
                <el-input v-model="ocrDialog.previewTable[scope.$index].createTime" placeholder="留资时间" size="small" />
              </template>
            </el-table-column>
            <el-table-column label="用户信息">
              <template slot-scope="scope">
                <el-input v-model="ocrDialog.previewTable[scope.$index].userInfo" placeholder="用户信息" size="small" />
              </template>
            </el-table-column>
            <el-table-column label="联系方式">
              <template slot-scope="scope">
                <el-input v-model="ocrDialog.previewTable[scope.$index].contact" placeholder="联系方式" size="small" />
              </template>
            </el-table-column>
            <el-table-column label="所在城市">
              <template slot-scope="scope">
                <el-input v-model="ocrDialog.previewTable[scope.$index].cityRemark" placeholder="所在城市" size="small" />
              </template>
            </el-table-column>
            <el-table-column label="留资路径">
              <template slot-scope="scope">
                <el-input v-model="ocrDialog.previewTable[scope.$index].leadPath" placeholder="留资路径" size="small" />
              </template>
            </el-table-column>
            <el-table-column label="特征标签">
              <template slot-scope="scope">
                <el-input v-model="ocrDialog.previewTable[scope.$index].featureTags" placeholder="特征标签" size="small" />
              </template>
            </el-table-column>
            </el-table>
        </div>
        <el-empty v-else-if="!ocrDialog.recognized" description="请上传表格图片，识别后此处显示可编辑预览" :image-size="90" />
        <div v-if="ocrDialog.importMessage" style="margin-top: 12px; color: #f56c6c;">{{ ocrDialog.importMessage }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="ocrDialog.recognized" type="primary" @click="confirmOcrImport" :loading="ocrDialog.importing">确认导入</el-button>
        <el-button @click="ocrDialog.visible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCustomerList,
  getCustomerById,
  addCustomer,
  updateCustomer,
  deleteCustomer,
  importCustomers,
  importOcrCustomers,
  importCustomerData,
  getCustomerAssignments,
  assignUserToCustomer,
  unassignUserFromCustomer,
  getAssignableUsers,
  searchUsers,
  batchAssignUsers,
  uploadCustomerImage,
  recognizeTableImage,
  uploadRowImage
} from '@/api/customerApi'
import { download } from '@/api/httpRequest'

export default {
  name: 'CustomerManage',
  data() {
    return {
      loading: false,
      customerList: [],
      selectedIds: [],
      selectedRows: [],
      total: 0,
      tableMaxHeight: window.innerHeight - 280,
      assignableUserOptions: [],
      queryParams: {
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        assignedUserId: null,
        pageNum: 1,
        pageSize: 10
      },
      dialog: {
        title: '新增客户',
        visible: false
      },
      form: {
        id: null,
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        remark: '',
        customerImageUrl: ''
      },
      rules: {
        contact: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        userInfo: [{ required: true, message: '请输入用户信息', trigger: 'blur' }]
      },
      assignmentDialog: {
        visible: false,
        customerId: null,
        tempUserId: null,
        list: [],
        searchResults: [],
        loading: false
      },
      batchDialog: {
        visible: false,
        items: [],
        loading: false
      },
      importDialog: {
        visible: false,
        fileList: [],
        loading: false,
        importData: null,
        batchAssignUserIds: [],
        batchUserMap: {},
        showUserSelect: false,
        tempUserId: null,
        userOptions: []
      },
      ocrDialog: {
        visible: false,
        loading: false,
        importing: false,
        uploaded: false,
        recognized: false,
        currentImageUrl: '',
        currentUploadedImage: '',
        previewTable: [],
        importMessage: '',
        selectedUserId: null,
        userOptions: []
      },
      rowUploadRefs: {}
    }
  },
  mounted() {
    this.getList()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.tableMaxHeight = window.innerHeight - 280
    },
    async getList() {
      this.loading = true
      try {
        const res = await getCustomerList(this.queryParams)
        this.customerList = res.list || []
        this.total = res.total || 0
      } catch (e) {
        console.error('加载客户列表失败', e)
        this.$message.error('加载客户列表失败')
      } finally {
        this.loading = false
      }
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        assignedUserId: null,
        pageNum: 1,
        pageSize: this.queryParams.pageSize
      }
      this.getList()
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
      this.selectedRows = selection
    },
    handlePageChange(page) {
      this.queryParams.pageNum = page
      this.getList()
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.getList()
    },
    getRowIndex(index) {
      return (this.queryParams.pageNum - 1) * this.queryParams.pageSize + index + 1
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    goBack() {
      this.$router.push('/home/workbench')
    },
    handleAdd() {
      this.resetForm()
      this.dialog.title = '新增客户'
      this.dialog.visible = true
    },
    async handleUpdate(row) {
      try {
        const res = await getCustomerById(row.id)
        this.form = { ...res }
        this.dialog.title = '修改客户'
        this.dialog.visible = true
      } catch (e) {
        this.$message.error('获取客户详情失败')
      }
    },
    async submitForm() {
      try {
        await this.$refs.customerFormRef.validate()
        if (this.form.id) {
          await updateCustomer(this.form)
          this.$message.success('修改成功')
        } else {
          await addCustomer({ ...this.form, isFromPc: true })
          this.$message.success('新增成功')
        }
        this.dialog.visible = false
        this.getList()
      } catch (e) {
        if (e !== false) {
          this.$message.error(e.message || '操作失败')
        }
      }
    },
    async handleDelete(row) {
      const ids = row.id ? [row.id] : this.selectedIds
      if (ids.length === 0) {
        this.$message.warning('请选择要删除的客户')
        return
      }
      try {
        await this.$confirm('确定要删除选中的客户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteCustomer(ids)
        this.$message.success('删除成功')
        this.getList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    },
    resetForm() {
      this.form = {
        id: null,
        userInfo: '',
        contact: '',
        cityRemark: '',
        leadPath: '',
        featureTags: '',
        remark: '',
        customerImageUrl: ''
      }
      if (this.$refs.customerFormRef) {
        this.$refs.customerFormRef.clearValidate()
      }
    },
    triggerImageUpload() {
      this.$refs.imageInput.click()
    },
    async handleImageChange(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadCustomerImage(formData)
        this.form.customerImageUrl = res?.originUrl || res?.thumbUrl || res
        this.$message.success('图片上传成功')
      } catch (e) {
        this.$message.error('图片上传失败')
      }
      e.target.value = ''
    },
    removeFormImage() {
      this.form.customerImageUrl = ''
    },
    async openAssignment(row) {
      this.assignmentDialog.customerId = row.id
      this.assignmentDialog.list = []
      this.assignmentDialog.tempUserId = null
      this.assignmentDialog.searchResults = []
      try {
        const res = await getCustomerAssignments(row.id)
        this.assignmentDialog.list = res || []
      } catch (e) {
        console.error('加载分配列表失败', e)
      }
      this.assignmentDialog.visible = true
    },
    async handleUserDropdownChange(visible) {
      if (visible) {
        await this.loadSearchResults('')
      }
    },
    async loadSearchResults(keyword) {
      this.assignmentDialog.loading = true
      try {
        const res = await getAssignableUsers(keyword)
        const excludeIds = this.assignmentDialog.list.map(item => item.userId)
        this.assignmentDialog.searchResults = (res || []).filter(item => !excludeIds.includes(item.id))
      } catch (e) {
        console.error('搜索用户失败', e)
      } finally {
        this.assignmentDialog.loading = false
      }
    },
    async loadAssignableUsers(visible) {
      if (visible && this.assignableUserOptions.length === 0) {
        try {
          const res = await getAssignableUsers('')
          this.assignableUserOptions = res || []
        } catch (e) {
          console.error('加载用户列表失败', e)
        }
      }
    },
    async confirmAssignmentUser(userId) {
      if (!userId) return
      try {
        await assignUserToCustomer(this.assignmentDialog.customerId, userId)
        this.$message.success('分配成功')
        const res = await getCustomerAssignments(this.assignmentDialog.customerId)
        this.assignmentDialog.list = res || []
        this.assignmentDialog.tempUserId = null
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '分配失败')
      }
    },
    async handleUnassignUser(row) {
      try {
        await this.$confirm('确定要取消该员工的分配吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await unassignUserFromCustomer(this.assignmentDialog.customerId, row.userId)
        this.$message.success('取消分配成功')
        const res = await getCustomerAssignments(this.assignmentDialog.customerId)
        this.assignmentDialog.list = res || []
        this.getList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '取消分配失败')
        }
      }
    },
    async openBatchAssignment() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请先选择客户')
        return
      }
      // 加载每个客户的已分配员工列表
      this.batchDialog.loading = true
      const items = await Promise.all(this.selectedRows.map(async (row) => {
        try {
          const res = await getCustomerAssignments(row.id)
          return {
            ...row,
            tempUserId: null,
            searchResults: [],
            loading: false,
            assignedList: res || []
          }
        } catch (e) {
          return {
            ...row,
            tempUserId: null,
            searchResults: [],
            loading: false,
            assignedList: []
          }
        }
      }))
      this.batchDialog.items = items
      this.batchDialog.loading = false
      this.batchDialog.visible = true
    },
    async loadBatchSearchResults(index, keyword) {
      const item = this.batchDialog.items[index]
      if (!item) return
      item.loading = true
      try {
        const res = await getAssignableUsers(keyword)
        item.searchResults = (res || []).map(u => ({
          value: u.id,
          label: `${u.userName}(${u.nickName})`
        }))
      } catch (e) {
        console.error('搜索用户失败', e)
      } finally {
        item.loading = false
      }
    },
    async confirmBatchUser(index, userId) {
      if (!userId) return
      const item = this.batchDialog.items[index]
      if (!item) return
      try {
        await assignUserToCustomer(item.id, userId)
        this.$message.success('分配成功')
        // 从搜索结果中找到用户信息并添加到已分配列表
        const userInfo = item.searchResults.find(s => s.value === userId)
        if (!item.assignedList) item.assignedList = []
        item.assignedList.push({
          userId: userId,
          userName: userInfo?.label || `用户${userId}`
        })
        item.tempUserId = null
      } catch (e) {
        this.$message.error(e.message || '分配失败')
      }
    },
    async copyPreviousAssignment(index) {
      if (index <= 0) return
      const prev = this.batchDialog.items[index - 1]
      const current = this.batchDialog.items[index]
      if (!prev || !current) return

      // 获取当前客户已分配的员工ID列表
      const currentUserIds = (current.assignedList || []).map(u => u.userId)
      // 获取上一条客户已分配的员工ID列表
      const prevUserIds = (prev.assignedList || []).map(u => u.userId)

      // 需要移除的员工（在当前但不在上一条）
      const toRemove = currentUserIds.filter(id => !prevUserIds.includes(id))
      // 需要添加的员工（在上一条但不在当前）
      const toAdd = prevUserIds.filter(id => !currentUserIds.includes(id))

      try {
        // 取消分配的员工
        for (const userId of toRemove) {
          await unassignUserFromCustomer(current.id, userId)
        }
        // 添加分配的员工
        for (const userId of toAdd) {
          await assignUserToCustomer(current.id, userId)
        }
        // 重新加载当前行的已分配列表
        const res = await getCustomerAssignments(current.id)
        current.assignedList = res || []
        this.$message.success('已复制上一条分配')
      } catch (e) {
        this.$message.error(e.message || '复制失败')
      }
    },
    async removeBatchAssignedUser(index, userId) {
      const item = this.batchDialog.items[index]
      if (!item) return
      try {
        await unassignUserFromCustomer(item.id, userId)
        this.$message.success('已取消分配')
        item.assignedList = (item.assignedList || []).filter(u => u.userId !== userId)
      } catch (e) {
        this.$message.error(e.message || '取消分配失败')
      }
    },
    handleImport() {
      this.importDialog.visible = true
      this.importDialog.fileList = []
      this.importDialog.batchAssignUserIds = []
      this.importDialog.batchUserMap = {}
      this.importDialog.showUserSelect = false
      this.importDialog.tempUserId = null
      this.importDialog.userOptions = []
      this.loadImportUserOptions()
    },
    handleImportFileChange(file, fileList) {
      this.importDialog.fileList = fileList.slice(-1)
      this.importDialog.importData = file.raw
    },
    downloadTemplate() {
      const fileName = `customer_template_${new Date().getTime()}.xlsx`
      download('/customer/importTemplate', {}, fileName)
    },
    async loadImportUserOptions() {
      try {
        const res = await getAssignableUsers('')
        this.importDialog.userOptions = res || []
      } catch (e) {
        console.error('加载用户列表失败', e)
      }
    },
    showImportUserSelect() {
      this.importDialog.showUserSelect = true
      this.searchImportUser('')
    },
    async searchImportUser(query) {
      try {
        const res = await getAssignableUsers(query)
        this.importDialog.userOptions = res || []
      } catch (e) {
        console.error('搜索用户失败', e)
      }
    },
    confirmImportUser(userId) {
      if (!userId) return
      if (!this.importDialog.batchAssignUserIds.includes(userId)) {
        this.importDialog.batchAssignUserIds.push(userId)
        const option = this.importDialog.userOptions.find(row => row.id === userId)
        this.importDialog.batchUserMap[userId] = option ? `${option.userName}(${option.nickName})` : String(userId)
      }
      this.importDialog.showUserSelect = false
      this.importDialog.tempUserId = null
    },
    removeBatchAssignUser(userId) {
      this.importDialog.batchAssignUserIds = this.importDialog.batchAssignUserIds.filter(id => id !== userId)
      delete this.importDialog.batchUserMap[userId]
    },
    getUserName(value) {
      return value || '-'
    },
    async submitImport() {
      if (!this.importDialog.importData) {
        this.$message.warning('请选择要导入的文件')
        return
      }
      this.importDialog.loading = true
      try {
        const formData = new FormData()
        formData.append('file', this.importDialog.importData)
        if (this.importDialog.batchAssignUserIds.length > 0) {
          formData.append('userIds', this.importDialog.batchAssignUserIds.join(','))
        }
        await this.$http.post('/customer/importData', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        this.$message.success('导入成功')
        this.importDialog.visible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '导入失败')
      } finally {
        this.importDialog.loading = false
      }
    },
    openOcrDialog() {
      this.ocrDialog.visible = true
      this.ocrDialog.uploaded = false
      this.ocrDialog.recognized = false
      this.ocrDialog.currentImageUrl = ''
      this.ocrDialog.currentUploadedImage = ''
      this.ocrDialog.previewTable = []
      this.ocrDialog.importMessage = ''
      this.ocrDialog.selectedUserId = null
      this.ocrDialog.userOptions = []
      this.loadOcrUserOptions()
    },
    async loadOcrUserOptions() {
      try {
        const res = await getAssignableUsers('')
        this.ocrDialog.userOptions = res || []
      } catch (e) {
        console.error('加载用户列表失败', e)
      }
    },
    handleOcrChange(file) {
      this.ocrDialog.uploaded = true
      this.ocrDialog.recognized = false
      this.ocrDialog.importMessage = ''
      if (file.url) {
        this.ocrDialog.currentUploadedImage = file.url
      }
    },
    async handleOcrUpload(option) {
      this.ocrDialog.loading = true
      this.ocrDialog.uploaded = true
      this.ocrDialog.recognized = false
      this.ocrDialog.importMessage = ''
      this.ocrDialog.currentUploadedImage = URL.createObjectURL(option.file)
      const formData = new FormData()
      formData.append('file', option.file)
      try {
        const result = await recognizeTableImage(formData)
        this.ocrDialog.loading = false
        this.ocrDialog.recognized = true
        try {
          const payload = result || {}
          this.ocrDialog.currentImageUrl = payload.ocrImageUrl || ''
          if (payload.table && Array.isArray(payload.table)) {
            this.ocrDialog.previewTable = payload.table.map(row => ({
              createTime: row.createTime || '',
              userInfo: row.userInfo || '',
              contact: row.contact || '',
              cityRemark: row.cityRemark || '',
              leadPath: row.leadPath || '',
              featureTags: row.featureTags || '',
              customerImageUrl: row.customerImageUrl || ''
            }))
          }
        } catch (e) {
          console.error('解析识别结果失败', e)
          this.ocrDialog.importMessage = '解析识别结果失败'
        }
      } catch (error) {
        this.ocrDialog.loading = false
        this.ocrDialog.uploaded = false
        this.ocrDialog.recognized = false
        this.$message.error('图片识别失败')
      }
    },
    handleOcrRemove() {
      this.ocrDialog.currentUploadedImage = ''
      this.ocrDialog.previewTable = []
      this.ocrDialog.currentImageUrl = ''
      this.ocrDialog.importMessage = ''
      this.ocrDialog.uploaded = false
      this.ocrDialog.recognized = false
      if (this.$refs.ocrUploadRef) {
        this.$refs.ocrUploadRef.clearFiles()
      }
    },
    setRowUploadRef(el, index) {
      this.$set(this.rowUploadRefs, index, el)
    },
    triggerRowUpload(index) {
      const input = this.rowUploadRefs[index]
      if (input) {
        input.click()
      }
    },
    async handleRowFileSelect(e, index) {
      const input = e.target
      const file = input.files?.[0]
      if (!file) return
      this.$set(this.ocrDialog.previewTable[index], '_uploading', true)
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadRowImage(formData)
        const url = res.data || res.message || res
        if (url && url.startsWith('http')) {
          this.$set(this.ocrDialog.previewTable[index], 'customerImageUrl', url)
          this.$message.success('图片上传成功')
        } else {
          throw new Error('上传返回格式异常')
        }
      } catch (e) {
        this.$message.error('图片上传失败')
      } finally {
        this.$set(this.ocrDialog.previewTable[index], '_uploading', false)
        input.value = ''
      }
    },
    removeOcrRowImage(index) {
      this.ocrDialog.previewTable[index].customerImageUrl = ''
    },
    openImagePreview(url) {
      if (!url) return
      const div = document.createElement('div')
      div.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);z-index:9999;display:flex;justify-content:center;align-items:center;'
      const img = document.createElement('img')
      img.src = url
      img.style.cssText = 'max-width:90%;max-height:90%;object-fit:contain;'
      div.appendChild(img)
      div.onclick = () => document.body.removeChild(div)
      document.body.appendChild(div)
    },
    async confirmOcrImport() {
      const rows = this.ocrDialog.previewTable
        .filter(row => row.contact)
        .map(row => ({
          contact: row.contact,
          cityRemark: row.cityRemark,
          userInfo: row.userInfo,
          leadPath: row.leadPath,
          featureTags: row.featureTags,
          remark: row.createTime || undefined,
          customerImageUrl: row.customerImageUrl || undefined
        }))
      if (rows.length === 0) {
        this.ocrDialog.importMessage = '请至少填写一行联系方式'
        return
      }
      this.ocrDialog.importing = true
      try {
        const userIds = this.ocrDialog.selectedUserId ? [this.ocrDialog.selectedUserId] : []
        const res = await this.$http.post('/customer/importOcr', {
          customerList: rows,
          ocrImageUrl: this.ocrDialog.currentImageUrl || undefined,
          userIds: userIds
        })
        this.$message.success(`识别导入成功，共 ${rows.length} 条`)
        this.ocrDialog.visible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '识别导入失败')
      } finally {
        this.ocrDialog.importing = false
      }
    },
    async handleExport() {
      if (this.customerList.length === 0) {
        this.$message.warning('没有可导出的数据')
        return
      }
      try {
        this.$message.info('正在导出...')
        const params = { ...this.queryParams, pageNum: 1, pageSize: 10000 }
        const res = await getCustomerList(params)
        const data = res.list || []
        
        // 构建CSV内容
        const headers = ['用户信息', '联系方式', '城市备注', '留资路径', '特征标签', '备注', '已分配员工', '创建时间']
        const rows = data.map(item => [
          item.userInfo || '',
          item.contact || '',
          item.cityRemark || '',
          item.leadPath || '',
          item.featureTags || '',
          item.remark || '',
          item.assignUserNames || '',
          this.formatDate(item.createTime)
        ])
        
        const csvContent = [headers, ...rows]
          .map(row => row.map(cell => `"${(cell || '').toString().replace(/"/g, '""')}"`).join(','))
          .join('\n')
        
        const BOM = '\uFEFF'
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `客户资料_${new Date().toLocaleDateString()}.csv`
        link.click()
        URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    }
  }
}
</script>

<style scoped>
.customer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  overflow: auto;
}

.page-header {
  background: #fff;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 15px 20px;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
}

.el-table {
  background: #fff;
  border-radius: 4px;
}

.cell-with-image {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-image {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  flex-shrink: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 15px;
}

.total-text {
  font-size: 14px;
  color: #606266;
}

.image-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
}

.image-upload i {
  font-size: 28px;
  margin-bottom: 4px;
}

.image-upload span {
  font-size: 12px;
}

.image-preview-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
}

.upload-preview {
  width: 100px;
  height: 100px;
  border-radius: 4px;
}

.image-actions {
  position: absolute;
  top: -8px;
  right: -8px;
}

.assignment-search {
  margin-bottom: 0;
}

.import-content {
  padding: 20px;
}

.import-content >>> .el-upload {
  width: 100%;
}

.import-content >>> .el-upload-dragger {
  width: 100%;
  height: 200px;
}

.danger {
  color: #f56c6c;
}
</style>
